import { Add, Remove } from '@mui/icons-material';
import { Box, IconButton, MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { luggageQuantity, TransferLuggageDraft } from '../transferLuggage';
import { SearchField, SearchRow } from './SearchBar';

export function TransferLuggagePicker({
  value,
  onChange,
}: {
  value: TransferLuggageDraft;
  onChange: (value: TransferLuggageDraft) => void;
}) {
  const { t } = useTranslation();
  return (
    <SearchRow>
      <SearchField label={t('travelServices.transfers.luggage.label')} width={260}>
        <TextField
          select
          fullWidth
          size="small"
          label={t('travelServices.transfers.luggage.label')}
          value={value.mode}
          onChange={(event) => onChange({ ...value, mode: event.target.value as TransferLuggageDraft['mode'] })}
        >
          {(['later', 'none', 'specified'] as const).map((mode) => (
            <MenuItem key={mode} value={mode}>
              {t(`travelServices.transfers.luggage.${mode}`)}
            </MenuItem>
          ))}
        </TextField>
      </SearchField>
      {value.mode === 'specified' &&
        (['checked', 'carryOn'] as const).map((field) => {
          const quantity = luggageQuantity(value[field]);
          const label = t(`travelServices.transfers.luggage.${field}`);
          return (
            <SearchField key={field} label={label} width={240}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <IconButton
                  size="small"
                  aria-label={t('travelServices.transfers.luggage.decrease', { label })}
                  disabled={quantity === null || quantity === 0}
                  onClick={() => onChange({ ...value, [field]: String(Math.max(0, (quantity ?? 0) - 1)) })}
                >
                  <Remove fontSize="small" />
                </IconButton>
                <TextField
                  size="small"
                  fullWidth
                  label={label}
                  value={value[field]}
                  // Text + numeric keyboard has no native wheel increment behavior.
                  type="text"
                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                  error={quantity === null}
                  helperText={quantity === null ? t('travelServices.transfers.luggage.invalid') : undefined}
                  onChange={(event) => onChange({ ...value, [field]: event.target.value })}
                />
                <IconButton
                  size="small"
                  aria-label={t('travelServices.transfers.luggage.increase', { label })}
                  disabled={quantity !== null && quantity >= Number.MAX_SAFE_INTEGER}
                  onClick={() => onChange({ ...value, [field]: String((quantity ?? 0) + 1) })}
                >
                  <Add fontSize="small" />
                </IconButton>
              </Box>
            </SearchField>
          );
        })}
    </SearchRow>
  );
}
